import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, Pill } from '../../shared';
import { CardBody } from '../../shared/card/card-body';
import './card-clients.scss';
import { ApplicationStatus } from '../../../shared/types/enums';
export var CardClientDetailsBody = function (_a) {
    var cases = _a.cases;
    var statuses = ApplicationStatus;
    var list = cases === null || cases === void 0 ? void 0 : cases.map(function (_a) {
        var applicationId = _a.applicationId, applicationStatusId = _a.applicationStatusId;
        var applicationStatus = applicationStatusId;
        return (React.createElement(Link, { key: applicationId, to: "cases/case/".concat(applicationId) },
            React.createElement("div", { className: "s-card-client__detail" },
                React.createElement("div", { className: "s-card-client__detail__content" },
                    React.createElement("span", null,
                        "Case ID: ",
                        applicationId),
                    React.createElement(Pill, { status: applicationStatus }, statuses[applicationStatus])),
                React.createElement(Icon, { name: "chevronRight" }))));
    });
    return React.createElement(CardBody, null, list);
};
